<div>
  <div
    cdkOverlayOrigin
    #dropdownContainer="cdkOverlayOrigin"
    (click)="onInteractionAreaClick($event)"
  >
    <ng-content select="[interaction-area]"></ng-content>
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin() ?? dropdownContainer"
    [cdkConnectedOverlayOpen]="isOpened()"
    [cdkConnectedOverlayHasBackdrop]="false"
    [cdkConnectedOverlayPanelClass]="'ui-dropdown'"
    [cdkConnectedOverlayPositions]="dropdownPositions"
    (overlayOutsideClick)="onOutsideClick()"
  >
    <fr8bot-ui-dropdown-content>
      <ng-content select="[content-area]"></ng-content>
    </fr8bot-ui-dropdown-content>
  </ng-template>
</div>
